import { SidePanelLayer } from "@nova/constants"
import { InspectorPanelAccordionExport } from "../accordion/export/InspectorPanelAccordionExport"
import { InspectorPanelMetadata } from "../FlightPanelMetadata"
import { usePDFRasterDownloadButtonData } from "plugins/PDFRaster/usePDFRasterDownloadButtonData"
import { useAppSelector } from "integrations/redux/hooks"
import { selectRasterById } from "features/entity-caching/pdf-rasters/selectors"

export const InspectorPanelPDFRasterData = ({ id }: { id: string }) => {
    const raster = useAppSelector(selectRasterById(id))
    const downloadOptions = usePDFRasterDownloadButtonData()

    return (
        <div className="mb-2 flex flex-col gap-2">
            {/* Export */}
            <InspectorPanelAccordionExport
                exportOptions={downloadOptions.exportOptions}
                canOnlyPickOne={true}
            />

            <InspectorPanelMetadata
                entity={raster as SidePanelLayer}
                uploads={[]}
                completedUploadCount={1}
            />
        </div>
    )
}
